export default __webpack_public_path__ + "static/media/andean6.b7562024.jpg";